import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import OtpVerification from './OtpVerification';
import ResetPassword from './ResetPassword';

const AuthRoutes = () => {
  const [view, setView] = useState('login');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState([]);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);


  if (isAuthenticated) return null;

  return (
    <>
      {view === 'login' && <Login onForgotPassword={() => setView('forgot')} />}

      {view === 'forgot' && (
        <ForgotPassword
          onBackToLogin={() => setView('login')}
          onSuccess={(email) => {
            setEmail(email);
            setView('otp');
          }}
        />
      )}

      {view === 'otp' && (
        <OtpVerification
          email={email}
          onBackToLogin={() => setView('login')}
          onVerified={(otpArray) => {
            setOtp(otpArray);
            setView('reset');
          }}
        />
      )}

      {view === 'reset' && (
        <ResetPassword
          email={email}
          otp={otp}
          onBackToLogin={() => setView('login')}
        />
      )}
    </>
  );
};

export default AuthRoutes;
